<template>
    <div>
        <!-- 版权登记 -->
        <div class="dci_all">
            <div class="dci_bigbox">
                <div class="cz_box">
                    <div class="cz_right">
                        <p class="cz_right_tit" style="color:#FFFFFF">版权登记</p>
                        <p class="cz_right_t" style="color:#FFFFFF">作品的“身份证”，由版权局颁发，版权专家全程护航，安心出证</p>
                        <ul class="cz_right_list">
                            <li>
                                <img src='../../images/ksxz.png'/>
                                <span style="color:#F5F5F5">快速下证</span>
                                <span style="color:#BDBDBD">最快一个工作日完成</span>
                            </li>
                            <li>
                                <img src='../../images/jywy.png'/>
                                <span style="color:#F5F5F5">交易无忧</span>
                                <span style="color:#BDBDBD">不通过全额退款</span>
                            </li>
                            <li>
                                <img src='../../images/zysxt.png'/>
                                <span style="color:#F5F5F5">专业省心</span>
                                <span style="color:#BDBDBD">版权专家全流程服务</span>
                            </li>
                            <li>
                                <img src='../../images/tmbj.png'/>
                                <span style="color:#F5F5F5">透明便捷</span>
                                <span style="color:#BDBDBD">统一价格，全线上操作</span>
                            </li>
                        </ul>
                        <div class="dci_right_btn">
                            <a style="float:left;margin-right:25px" class="yellow" @click="lijiDci">
                                <span>立即登记</span>
                                <i></i>
                                <!-- <img src='../../images/dci_go.png'/> -->
                            </a>
                            <!--<a style="margin-left:24px">
                                <span @click="lookDciDetail">查看详情</span>
                                <img src='../../images/dci_go.png'/>
                            </a>-->
                        </div>
                    </div>
                    <img src='../../images/dci_zhengshu.gif' class="dci_zhengshu"/>
                </div>
            </div>
            <div class="fwlc_box">
                <h2>服务流程</h2>
                <ul>
                    <li class="dci_cont">
                        <p><img src="../../images/smrz.png" style="width:31px;height:26px"/></p>
                        <p>实名认证</p>
                        <p>完成个人/企业实名认证</p>
                    </li>
                    <li class="dci_jt"><img src="../../images/dcialive.png"/></li>
                    <li class="dci_cont">
                        <p><img src="../../images/sczp.png" style="width:34px;height:34px"/></p>
                        <p>上传作品</p>
                        <p>填写信息，上传作品</p>
                    </li>
                    <li class="dci_jt"><img src="../../images/dcialive.png"/></li>
                    <li class="dci_cont">
                        <p><img src="../../images/xzbl.png" style="width:34px;height:34px"/></p>
                        <p>协助办理</p>
                        <p>全程协助资料提交</p>
                    </li>
                    <li class="dci_jt"><img src="../../images/dcialive.png"/></li>
                    <li class="dci_cont">
                        <p><img src="../../images/bqjsh.png" style="width:28px;height:32px"/></p>
                        <p>版权局审核</p>
                        <p>1-10个工作日完成审核</p>
                    </li>
                    <li class="dci_jt"><img src="../../images/dcialive.png"/></li>
                    <li class="dci_cont">
                        <p><img src="../../images/bfzs.png" style="width:33px;height:24px"/></p>
                        <p>颁发证书</p>
                        <p>获得作品登记证书</p>
                    </li>
                </ul>
            </div>
        </div>
        
    </div>
</template>

<script>
    

    export default {
        metaInfo: {
            title: '版权登记|版权保护-版权服务专家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权登记,版权保护,版权登记查询,版权保护中心,版权保护服务,版权登记服务,版权家'
            },{
                name: 'Description',
                content: '版权家是专业提供版权登记查询，版权保护申请；我们作为版权保护服务专家，为版权人提供极致的版权登记咨询、版权交易、版权监测、版权维权等服务体验。'
            }]
        },
        name:'indexfour',
        components:{
            
        },
        data(){
            return {
               
            }
        },

        methods:{
            lijiDci(){
                window.open('/copyrightRegistration', '_blank')
            },
        }

    }
</script>

<style scoped lang="less">
//版权登记
    .dci_all{
        position: relative;
        height:863px;
        .dci_bigbox{
            background: url("../../images/dci_bg.png") no-repeat;
            width: 100%;
            height: 646px;
            background-size: cover;
            .cz_box{
                .cz_right{
                    margin-top: 131px;
                }
            }
            // padding-top:100px;
            // box-sizing: border-box;
        }
        .fwlc_box{
            position: absolute;
            width: 1200px;
            height: 205px;
            background: #FFFFFF;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            border-radius: 20px;
            top: 579px;
            left: 50%;
            margin-left: -600px;
            h2{
                font-size: 24px;
                font-weight: bold;
                color: #333333;
                line-height: 36px;
                margin: 19px 0 10px;
                text-align: center;
                font-family:SourceHanSansCN;
            }
            ul{
                display: flex;
                .dci_cont{
                    flex: 1;
                    text-align:center;
                }
                .dci_jt{
                    width: 26px;
                    margin-top: 45px;
                }
                li{
                    &>img{
                        width: 26px;
                        height: 14px;
                    }
                    p:nth-of-type(1){
                        width: 54px;
                        height: 54px;
                        border-radius: 50%;
                        background: #FFFFFF;
                        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        margin:auto;
                    }
                    p:nth-of-type(2){
                        font-size: 16px;
                        font-weight: bold;
                        font-family:SourceHanSansCN;
                        color: #333333;
                        line-height: 24px;
                        margin:6px 0 2px;
                    }
                    p:nth-of-type(3){
                        font-size: 11px;
                        color: #999999;
                        line-height: 17px;
                    }
                }
                
            }
        }
    }
    //版权存证
    .cz_box{
        display: flex;
        width: 1200px;
        margin: 0px auto 130px;
        .cz_zhengshu{
            width: 540px;
            height: 390px;
            display: block;
            margin: 103px 0 0 21px;
        }
        .dci_zhengshu{
             width:540px;
            height:390px;
            display: block;
                margin-top: 97px;
            // margin: 0 115px 0 47px;
        }
        .cz_right{
            flex:1;
            margin-top: 128px;
            margin-left: 100px;
            .cz_right_tit{
                font-size: 32px;
                font-weight: bold;
                font-family:SourceHanSansCN;
                color: #333333;
                line-height: 47px;
                margin:0px 0 16px; 
            }
            .cz_right_t{
                font-size: 16px;
                font-weight: bold;
                font-family:SourceHanSansCN;
                color: #333333;
                line-height: 27px;
            }
            .cz_right_list{
                display: flex;
                margin-top:40px;
                margin-bottom:56px;
                li{
                    // flex:1;
                    // width: 130px;
                    width:84px;
                    margin-right:79px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    img{
                        width:46px;
                        height:46px;
                        display: block;
                        margin: 0 38px;
                    }
                    span:nth-of-type(1){
                        font-size: 16px;
                        font-weight: 500;
                        font-family:SourceHanSansCN;
                        color: #333333;
                        line-height: 27px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 5px 0 3px;
                        text-align: center;
                    }
                    span:nth-of-type(2){
                        font-size: 12px;
                        color: #555555;
                        line-height: 18px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        text-align: center;
                    }
                }
            }
            .dci_right_btn{
                .yellow{
                    font-size: 14px;
                    color: #F5F5F5;
                    line-height: 40px;
                    width: 154px;
                    height: 40px;
                    border-radius: 20px;
                    display: inline-block;
                    cursor: pointer;
                    position: relative;
                    padding-left: 38px;
                    background: #FBDA5D;
                    border: 1px solid #FBDA5D;
                    color: #333333;
                    i{
                        margin-left: 6px;
                        width: 14px;
                        height: 14px;
                        display:inline-block;
                        position: absolute;
                        top: 13px;
                        background: url("../../images/goHover.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    &:hover{
                        box-shadow: 0px 4px 8px 0px rgba(255, 216, 0, 0.6);
                    }
                }
                // a{
                //     font-size: 14px;
                //     color: #F5F5F5;
                //     line-height: 40px;
                //     width: 154px;
                //     height: 40px;
                //     border-radius: 20px;
                //     border: 1px solid #E5E5E5;
                //     display: inline-block;
                //     // text-align: center;
                //     // display: flex;
                //     // justify-content: center;
                //     // align-items: center;
                //     cursor: pointer;
                //     position: relative;
                //     padding-left: 38px;
                //     i{
                //         margin-left: 6px;
                //         width: 14px;
                //         height: 14px;
                //         display:inline-block;
                //         position: absolute;
                //         top: 13px;
                //         background: url("../../images/dci_go.png") no-repeat;
                //         background-size: 100% 100%;
                //     }
                //     &:hover{
                //         background: #FBDA5D;
                //         border: 1px solid #FBDA5D;
                //         color: #333333;
                //         i{
                //             margin-left: 6px;
                //             width: 14px;
                //             height: 14px;
                //             display:inline-block;
                //             position: absolute;
                //             top: 13px;
                //             background: url("./images/goHover.png") no-repeat;
                //             background-size: 100% 100%;
                //         }
                //     }
                // }
            }
            .cz_right_btn{
                .yellow{
                    cursor: pointer;
                    font-size: 14px;
                    line-height: 40px;
                    width: 154px;
                    height: 40px;
                    border-radius: 20px;
                    border: 1px solid #E5E5E5;
                    display: inline-block;
                    position: relative;
                    padding-left: 38px;
                    background: #FBDA5D;
                    border: 1px solid #FBDA5D;
                    color: #333333;
                    // text-align: center;
                    span{
                        margin-left: 6px;
                        width: 14px;
                        height: 14px;
                        background: url("../../images/goHover.png") no-repeat;
                        background-size: 100% 100%;
                        display: inline-block;
                        position: absolute;
                        top: 13px;
                    }
                    &:hover{
                        box-shadow: 0px 4px 8px 0px rgba(255, 216, 0, 0.6);
                    }
                }
                .normal{
                    cursor: pointer;
                    font-size: 14px;
                    color: #666666;
                    line-height: 40px;
                    width: 154px;
                    height: 40px;
                    border-radius: 20px;
                    border: 1px solid #E5E5E5;
                    display: inline-block;
                    position: relative;
                    padding-left: 38px;
                    // text-align: center;
                    span{
                        margin-left: 6px;
                        width: 14px;
                        height: 14px;
                        background: url("../../images/go.png") no-repeat;
                        background-size: 100% 100%;
                        display: inline-block;
                        position: absolute;
                        top: 13px;
                    }
                    &:hover{
                        background: #FBDA5D;
                        border: 1px solid #FBDA5D;
                        color: #333333;
                        box-shadow: 0px 4px 8px 0px rgba(255, 216, 0, 0.6);
                        span{
                            margin-left: 6px;
                            width: 14px;
                            height: 14px;
                            background: url("../../images/goHover.png") no-repeat;
                            background-size: 100% 100%;
                            display: inline-block;
                            position: absolute;
                            top: 13px;
                        }
                    }
                }
            }
        }
    }
    ul{
        li{
            list-style: none;
        }
    }
</style>